import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from "@angular/core";
import _ from "lodash";
import * as moment from "moment";
import { Moment } from "moment";
import { Subject } from "rxjs";
import { tap, takeUntil, share } from "rxjs";
import { NzMessageService } from "ng-zorro-antd/message";
import { PlatformType } from "@root/config";
import { Translate } from "@root/util/decorator";
import { InternationalService } from "@root/international.service";
import { AppService } from "@root/app.service";
import {
  Parent,
  DateRange,
  EntityData,
  MultiHouseCalendarService,
} from "@root/router/component/calendar/multi-house-calendar/multi-house-calendar.service";

enum HouseType {
  House = 0,
  Type = 1,
}
interface DataOfShortcut {
  status: "open" | "close" | "diff" | "past";
  type?: HouseType;
  list?: {
    0?: Array<any>;
    1?: Array<any>;
  };
}
@Component({
  selector: "host-month-price-calendar-v2",
  templateUrl: "./month-price-calendar-v2.component.html",
  styleUrls: ["./month-price-calendar-v2.component.scss"],
})
export class MonthPriceCalendarV2Component implements OnInit, OnDestroy {
  @Input() cellWidth = 70;
  @Input() cellHeight = 78;
  @Input() headerHeight = 39;
  @Input() currency;
  @Input() relatedHouse: Parent;
  @Input() calendarMap;
  @Input() thirdparty;
  @Input() uniqueKey;

  @Input()
  set currentDate(value: string) {
    this._currentDate = value;
    this._currentYear = moment(value).year();
    this._currentMonth = moment(value).month();
  }

  @Output() onSelectCell = new EventEmitter();
  @Output() onClickChangeAvailable = new EventEmitter();
  @Output() onClickChangeTab = new EventEmitter<number>();
  @Output() monthChange = new EventEmitter();

  _currentDate = moment().format("YYYY-MM");
  _currentYear = moment().year();
  _currentMonth = moment().month();

  /** 选中状态需要的数据 */
  @Input() listOfSelectedDates: DateRange = {
    // id: 0,
    head: null,
    last: null,
  };

  // listOfSelectedData: EntityData = {
  //   id: 0,
  //   thirdparty: null,
  //   related: null,
  // };

  /** 快捷气泡需要的数据 */
  dataOfShortcut: DataOfShortcut = {
    status: "open",
    list: {},
  };
  @Input() selectStatus: "none" | "doing" | "done" = "none";
  displayShortcutPop = false;
  private token = Math.random();
  private select$ = this.calendarService.selectRaw$.pipe(
    tap((value) => {
      const { head, last } = value.dates;
      const status = value.status;

      if (status === "done" && (value.token === this.token || !value.token)) {
        const sliced = _.filter(
          this.calendarMap,
          (c) => head.isSameOrBefore(c.date, "d") && last.isSameOrAfter(c.date, "d"),
        );
        this.updateDataOfShortcut(sliced);
        setTimeout(() => {
          this.displayShortcutPop = true;
        }, 500);
      } else {
        this.displayShortcutPop = false;
      }
      this.selectStatus = value.status;
      this.listOfSelectedDates = value.dates;
      // this.listOfSelectedData = value.data;
      // this.displayShortcutPop = true;
    }),
  );

  private destroy$ = new Subject();

  get isInternational() {
    return this.app.app.international;
    // return this.international.isInternational();
  }

  /** 当前房源 */
  get entity() {
    return this.relatedHouse?.p_children.find((child) => child.c_id === this.uniqueKey);
  }

  @Translate("component.month_calendar_v2.historical_price_cannot_be_changed") historyWarning;

  constructor(
    private calendarService: MultiHouseCalendarService,
    private messageService: NzMessageService,
    private international: InternationalService,
    private app: AppService,
  ) {}

  ngOnInit() {
    // this.select$.pipe(takeUntil(this.destroy$)).subscribe();
  }

  toggleSelecting(date) {
    const dateStr = date.title;

    if (date.date.isBefore(moment().subtract(1, "d"), "d")) {
      this.messageService.warning(this.historyWarning);
      return;
    }

    if (this.calendarMap[dateStr] && this.calendarMap[dateStr].reservation) {
      return;
    }

    if (this.selectStatus === "none" || this.selectStatus === "done") {
      this.selectStatus = "doing";

      this.select({
        head: date.date,
        last: date.date,
      });
      // this.listOfSelectedDates = {
      //   head: date.date,
      //   last: date.date
      // };
    } else {
      this.selectStatus = "done";
      const data = this.listOfSelectedDates;
      /** 结束托选后，需要排一下序，防止反向托选时head大于last */
      const [head, last] = [moment.min(data.head, data.last), moment.max(data.head, data.last)];

      // const relatedHouse = this.relatedHouse;

      // _.assign(relatedHouse, {
      //   currentThirdparty: this.thirdparty,
      //   currentId: data.id,
      // });

      this.select({ head, last });
    }
  }

  updateSelectedDates(date) {
    if (this.selectStatus !== "doing") {
      return;
    }

    /** 鼠标移动到了订单 */
    if (_.get(this.calendarMap[date.title], "reservation")) {
      return;
    }

    /** 选择了过去日期 */
    if (date.date.isBefore(moment(), "d")) {
      return;
    }

    const { last } = this.listOfSelectedDates;

    this.select({
      ...this.listOfSelectedDates,
      last: date.date,
    });
    // this.listOfSelectedDates = {
    //   ...this.listOfSelectedDates,
    //   last: date.date
    // };

    /**
     * 做一次全面检查，查看所选日期之内是否有订单
     * 如果有订单，则不允许选中
     */
    const dates = _.filter(_.values(this.calendarMap), (item) => this.isBetween(moment(item.date)));
    if (_.find(dates, (d) => d.reservation)) {
      this.select({
        ...this.listOfSelectedDates,
        last,
      });
      // this.listOfSelectedDates = {
      //   ...this.listOfSelectedDates,
      //   last
      // };
    }
  }

  isBetween(date: Moment) {
    const { head, last } = this.listOfSelectedDates;

    if (!head && !last) {
      return;
    }

    const [_head, _last] = [moment.min(head, last), moment.max(head, last)];

    return moment(date).isSameOrAfter(_head, "d") && moment(date).isSameOrBefore(_last, "d");
  }

  isHead(date: Moment) {
    const { head, last } = this.listOfSelectedDates;
    if (!head && !last) {
      return;
    }
    return moment(date).isSame(moment.min(head, last), "d");
  }

  isLast(date: Moment) {
    const { head, last } = this.listOfSelectedDates;
    if (!head && !last) {
      return;
    }
    return moment(date).isSame(moment.max(head, last), "d");
  }

  // getReservationColor(calendar) {
  //   const reservation = calendar.__reservation;
  //   if (this.reservationStyle === 'channel') {
  //     /** 按渠道显示订单颜色 */
  //     const code =
  //       reservation.thirdparty_type === 5
  //         ? reservation.handmade_chanel
  //         : reservation.thirdparty_type === 6
  //         ? 23
  //         : reservation.thirdparty_type;
  //     const channel = this.channelColorMap[code];
  //     return channel ? channel.color : '#B9B9B9';
  //   } else {
  //     /** 按状态显示订单颜色 */
  //     return calendar.__reservationBefore
  //       ? '#22975d'
  //       : calendar.__reservationChecking
  //       ? '#db5172'
  //       : '#3475bc';
  //   }
  // }

  // getChannelName(reservation) {
  //   if (reservation.thirdparty_type === 5) {
  //     /** 取渠道名 */
  //     const channel = this.channelColorMap[reservation.handmade_chanel];
  //     if (channel) {
  //       return channel.channel_name;
  //     }
  //   } else {
  //     /** 取平台名 */
  //     const platform = PLATFORM_TYPE_INFO[reservation.thirdparty_type];
  //     if (platform) {
  //       return platform.name;
  //     }
  //   }
  // }

  updateDataOfShortcut(calendars = []) {
    if (_.isEmpty(calendars)) {
      return;
    }

    let status: "open" | "close" | "diff" | "past" = "open";
    let list = null;

    const head = _.head(calendars);
    if (head.type === "past") {
      this.dataOfShortcut = { status: "past", list };
      return;
    }

    if (calendars.length === 1) {
      /**
       * 单天分为 打开  关闭  不一致三种状态
       * 其中不一致状态需要显示具体不一致的渠道信息
       */
      const calendar = _.head(calendars) || {};
      if (calendar.available === 0) {
        status = "close";
      } else if (calendar.available === 1) {
        status = "open";
      } else {
        status = "diff";

        list = _.groupBy(calendar.housing_status, "available");
      }
    } else {
      /**
       * 多天分为 打开  关闭  不一致三种状态
       * 不一致状态不需要显示具体渠道信息
       */
      if (_.every(calendars, (calendar) => calendar.available === 0)) {
        status = "close";
      } else if (_.every(calendars, (calendar) => calendar.available === 1)) {
        status = "open";
      } else {
        status = "diff";
      }
    }

    const type = this.relatedHouse.p_type;
    this.dataOfShortcut = { status, list, type };
    console.log("dataOfSelectedDates: ", this.dataOfShortcut);
  }

  getPrice(date) {
    const currency = this.currency;
    const price = _.get(this.calendarMap, [date, "price"]) || 0;
    return this.thirdparty === PlatformType.Ctrip && price === -1 ? "" : `${price}`;
  }

  changeHouseAvailable(status: 0 | 1, event) {
    // if (!this.hasWritePermission()) {
    //   this.modalService.warning({
    //     nzTitle: '暂无修改权限，请联系管理员'
    //   });
    //   return;
    // }
    event.stopPropagation();
    this.onClickChangeAvailable.emit({
      status,
    });
    this.calendarService.cancelSelect();
  }

  changeTab(name) {
    event.stopPropagation();
    this.onClickChangeTab.emit(name);
    this.displayShortcutPop = false;
    // this.calendarService.changeTab(index);
  }
  select(value) {
    const { head, last } = value;
    const status = this.selectStatus;

    if (status === "done") {
      const sliced = _.filter(
        this.calendarMap,
        (c) => head.isSameOrBefore(c.date, "d") && last.isSameOrAfter(c.date, "d"),
      );
      this.updateDataOfShortcut(sliced);
      setTimeout(() => {
        this.displayShortcutPop = true;
      }, 500);
    } else {
      this.displayShortcutPop = false;
    }
    this.listOfSelectedDates = value;
    // this.listOfSelectedData = value.data;

    this.onSelectCell.emit({
      status: this.selectStatus,
      dates: { ...value },
      data: {
        type: "house",
        payload: this.entity,
      },
    });
    return;
    this.calendarService.select({
      status: this.selectStatus,
      dates: {
        ...value,
        // id: this.uniqueKey,
      },
      data: {
        id: this.uniqueKey,
        // thirdparty: this.thirdparty,
        // related: this.relatedHouse,
        // 以上字段废弃
        type: "house",
        payload: this.entity,
      },
      token: this.token,
    });
  }

  selectReservation(code) {
    this.calendarService.selectReservation(code);
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
